export const toCurrency = (
  amount,
  currencyCode,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  if (typeof amount !== "number") {
    amount = parseFloat(amount);
  }

  const locale =
    navigator.languages != undefined
      ? navigator.languages[0]
      : navigator.language;

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(amount);
};

export const pluralize = (word, amount) => {
  return amount > 1 || amount == 0 ? `${word}s` : word;
};
